import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Bongo from './Bongo';

const XPGainAnimation = ({ amount, onComplete }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 0, scale: 0.5 }}
        animate={{ 
          opacity: [0, 1, 1, 0],
          y: -100,
          scale: [0.5, 1.2, 1, 0.8]
        }}
        transition={{
          duration: 1.5,
          ease: 'easeOut',
          times: [0, 0.2, 0.8, 1]
        }}
        onAnimationComplete={onComplete}
        className="fixed z-50 pointer-events-none"
        style={{ top: '40%', left: '50%', transform: 'translate(-50%, -50%)' }}
        data-testid="xp-gain-animation"
      >
        <div className="cozy-soft-halo flex flex-col items-center gap-1">
          <Bongo mood="success" size="small" />
          <span className="text-3xl font-extrabold text-[color:var(--cb-primary)] drop-shadow-lg">
            +{amount} XP
          </span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default XPGainAnimation;
